<template>
	<v-header title="体检预约" headerLeftStatus="true" />
	<div class="sysMain">
		<div class="sysMainBody">
			<Row justify="center" align="middle">
				<Col flex="70px" style="padding-left: 5px; ">体检单</Col>
				<Col flex="auto" style="font-weight: bold;padding-left: 5px; ">{{model.patientName+'/'+model.patient}}
				</Col>
			</Row>
			<Row justify="center" align="middle">
				<Col flex="70px" style="padding-left: 5px;">体检日期</Col>
				<Col flex="auto" style="padding-left: 5px; "><Input v-model="model.examinateTime" placeholder="选择体检日期"
					disabled style="width: 100%; padding-right: 10px;" /></Col>
			</Row>
			<div style="font-size:12px;">
				<v-calendar :markDateMore="poolList" v-on:choseDay="calendarClick">
				</v-calendar>
				<Divider>注意事项</Divider>
				<div class="ivu-m-16" v-html="view.infoNote"></div>
			</div>
			<Drawer :title="model.patientName+'/'+model.patient+'   '+model.examinateTime" placement="bottom"
				:mask-closable="false" height="100%" v-model="view.showDrawerDepartList">
				<Card style="width:100%;margin-bottom: 10px;" v-for="item in departList">
					<template #title>
						{{item.departName}}
						<Tag v-show='converterEx.toStringTime(item.appointmentTime)===""' color="error">未预约
						</Tag>
					</template>
					<template #extra>
						{{converterEx.toStringTime(item.appointmentTime)!==""?'原约 '+converterEx.toDateTime2String(item.appointmentTime,model.examinateTime):""}}
					</template>
					<Row style="text-align: center;">
						<Col span="12"
							style="border-style: none dashed none none;border-color: #DDDFE0;border-width: 1px;">
						<b tyle="font-size: 16px;  padding-right: 10px;">上午&ensp;</b>
						<Button shape="circle" disabled v-show="item.morning===0">已排满</Button>
						<Button shape="circle" @click="departQueueDetail(item,'上午')">余{{item.morning}}</Button>
						</Col>
						<!-- 厦门不要
						<Col span="12">
						<b tyle="font-size: 16px;  padding-right: 10px;">下午&ensp;</b>
						<Button shape="circle" disabled v-show="item.afternoon===0">已排满</Button>
						<Button shape="circle" @click="departQueueDetail(item,'下午')">余{{item.afternoon}}</Button>
						</Col>
						-->
					</Row>
				</Card>
			</Drawer>
			<Drawer :title="model.departName+' '+model.examinateTime" placement="bottom" :mask-closable="false"
				height="100%" v-model="view.showDrawerDepartDetail">
				<Row v-for="itemList in departDetail" style="text-align: center;padding-bottom: 10px;">
					<Col v-for="item in itemList" span="6">
						<Button shape="circle" @click="queue(item)">{{item.queueTime}}</Button>
					</Col>
				</Row>
			</Drawer>
		</div>
	</div>
</template>
<script>
	import header from "@/components/header/index";
	import calendar from "@/components/calendar/calendar.vue";
	import {
		sysPost
	} from '@/utils/api'
	export default {
		name: 'yuyueDepart',
		data() {
			return {
				view: {
					showDrawerDepartList: false,
					showDrawerDepartDetail: false,
					infoNote: "", //注意事项
				},
				poolList: [],
				departList: [],
				departDetail: [],
				model: {
					patient: "",
					patientName: "",
					examinateTime: "",
					depart: "",
					departName: "",
				},
			};
		},
		created() {
			this.model.patient = this.$route.query.Patient;
			this.model.patientName = this.$route.query.PatientName;
			this.getAppointmentInfoNote();
			this.departQueuePoolSearch();
		},
		methods: {
			getAppointmentInfoNote() { //获取预约注意事项
				var that = this;
				sysPost(that, {
					"url": 'Common/GetDefaultValue',
					"data": {
						"DefaultValue": "AppointmentInfoNote"
					}
				}, function(result) {
					that.view.infoNote = result?.dvRemark;
				})
			},
			departQueuePoolSearch() {
				var that = this;
				sysPost(that, {
					"url": 'Queue/GetQueueList',
					"data": {
						"Patient": that.model.patient
					}
				}, function(result) {
					that.poolList = result;
				})
			},
			calendarClick(data) {
				var that = this;
				var dateString = this.converterEx.toStringEx(new Date(parseFloat(new Date(data).getTime())), "yyyy-MM-dd");
				if (this.poolList.existsEx(function(p) {
						return that.converterEx.toDateString(p.dateTime) == dateString
					})) {
					this.model.examinateTime = dateString;
					this.departQueueList();
				} else this.model.examinateTime = "";
			},
			departQueueList() {
				var that = this;
				sysPost(that, {
					"url": 'Queue/DepartQueueList',
					"data": {
						"Patient": this.model.patient,
						"AppointmentTime": this.model.examinateTime
					}
				}, function(result) {
					that.departList = result;
					that.view.showDrawerDepartList = true;
				});
			},
			departQueueDetail(item, TimeQuantum) {
				var that = this;
				that.model.depart = item.depart;
				that.model.departName = item.departName;
				sysPost(that, {
					"url": 'Queue/DepartQueueDetail',
					"data": {
						"Patient":that.model.patient,
						"Depart": that.model.depart,
						"AppointmentDate":that.model.examinateTime,
						"TimeQuantum": TimeQuantum,
					}
				}, function(result) {
					that.departDetail = result.groupEx(4);
					that.view.showDrawerDepartDetail = true;
				});
			},
			queue(item) {
				var that = this;
				this.$Modal.confirm({
					title: '友情提示',
					content: '<p>您确认预约?</p>',
					onOk: () => {
						sysPost(that, {
							"url": 'Queue/Queue',
							"data": {
								"DepartQueuePool": item.departQueuePool,
								"Patient": that.model.patient
							}
						}, function(result) {
							that.departQueueList();
							that.view.showDrawerDepartDetail = false;
							that.$Message.success('操作成功！');
						});
					}
				});
			}
		},
		components: {
			"v-header": header,
			"v-calendar": calendar,
		}
	}
</script>